export default __webpack_public_path__ + "static/media/section2-img1-mob.9a8c03c5.png";